<!--
 * @Description: 成功案例
 * @Author: mileS
 * @Date: 2019-08-09 10:26:26
 * @LastEditTime: 2019-08-15 22:21:25
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="subject_math_container">
    <div class="section content">
      <div class="menu">
        <ul>
          <li class="item" v-for="(item, index) in dataList" :key="`nav-li${index}`" @click="jump(index)"
              :class="{'active': currentIndex === index }">
            <span class="range-icon" :class="{'active': currentIndex === index }"/>
            <span class="title">{{item.title}}</span>
          </li>
        </ul>
      </div>
      <div class="content-list">
        <ul class="list">
          <li v-for="(item, index) in dataList" :key="index" :class="['item', `data-item-${index}`]">
            <p class="title">{{ item.title }}</p>
            <div class="intro">
              <ul>
                <li class="">
                  <p class="intro-title">合作时间</p>
                  <p class="intro-detail">{{ item.time }}</p>
                </li>
                <li class="">
                  <p class="intro-title">合作模式</p>
                  <p class="intro-detail">{{ item.mode }}</p>
                </li>
<!--                <li class="">-->
<!--                  <p class="intro-title">机构规模</p>-->
<!--                  <p class="intro-detail">{{ item.scope }}</p>-->
<!--                </li>-->
              </ul>
            </div>
            <div class="info">
<!--              <img :src="item.pic" alt="" class="pic">-->
              <div class="des">
                <p>{{ item.content }}</p>
                <p class="author"><span>{{ item.author }}</span></p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import headBanner from '@/components/global/headBanner'
import { dataList } from './assets/data'

export default {
  components: { headBanner },
  data () {
    return {
      dataList, // 数据集合
      currentIndex: 0, // 左侧菜单导航列表
      domScrollInfoList: [] // dom 高度
    }
  },
  mounted () {
    this.getElementScrollInfoList()
    window.addEventListener('scroll', this.dataScroll)
  },
  methods: {
    /**
     * @Desc 获取移动元素滑动详情集合
     * */
    getElementScrollInfoList () {
      const containerGap = 20 // 第一个元素距顶部距离间隙
      const verticalGap = 20 // 元素垂直间隙
      this.$nextTick(() => {
        this.dataList.reduce((pre, v, i) => {
          const { clientHeight } = document.getElementsByClassName(`data-item-${i}`)[0]
          pre.push({
            clientHeight,
            scrollTop: i === 0 ? 0 : (pre[i - 1].scrollBot + 1),
            scrollBot: i === 0 ? (clientHeight + containerGap) : (pre[i - 1].scrollBot + clientHeight + verticalGap)
          })
          return pre
        }, this.domScrollInfoList)
      })
    },

    /**
     * @Desc 监听滑动，修改
     * @return {Object} e
     * */
    dataScroll (e) {
      const { scrollTop: windowScrollTop } = e.srcElement.scrollingElement
      const domScrollInfoList = this.domScrollInfoList
      for (let i = 0; i < domScrollInfoList.length; i++) {
        const { scrollTop, scrollBot } = domScrollInfoList[i]
        if ((windowScrollTop >= scrollTop && windowScrollTop <= scrollBot) || i + 1 === domScrollInfoList.length) {
          this.currentIndex = i
          break
        }
      }
      this.setMenuPosition(windowScrollTop, this.domScrollInfoList[this.domScrollInfoList.length - 1].scrollTop)
    },

    /**
     * @Desc 设置菜单 位置滑动
     * @params {Number} window 滑动距离
     * @params {Number} 最后一条数据滑动距离
     * */
    setMenuPosition (windowScrollTop, lastElementScrollTop) {
      if (windowScrollTop > lastElementScrollTop) {
        document.getElementsByClassName('menu')[0].style.position = 'absolute'
        document.getElementsByClassName('menu')[0].style.top = lastElementScrollTop + 20 + 'px'
      } else {
        document.getElementsByClassName('menu')[0].style.position = 'fixed'
        document.getElementsByClassName('menu')[0].style.top = '100px'
      }
    },

    /**
     * @Desc 点击菜单 滑动
     * @params {Number} 索引
     * */
    jump (index) {
      const { scrollTop } = this.domScrollInfoList[index]
      this.windowScroll(scrollTop)
    },

    /**
     * @Desc 窗口滑动
     * @params {Number} num 滑动距离
     * @return {String} theme
     * */
    windowScroll (num, theme = 'smooth') {
      window.scrollTo({
        top: num,
        behavior: theme
      })
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.dataScroll)
  }
}
</script>

<style scoped lang="scss">
.subject_math_container {
  position: relative;
  ul{
    padding-left: 0;
  }
  margin-top: 80px;
  padding-bottom: 300px;
  background-color: #F8F9FD;
  .content{
    margin: 0 auto;
    padding-top: 20px;
    width: 1106px;
    display: flex;
   .menu{
     position: absolute;
     background: #ffffff;
     margin-right: 20px;
     padding: 20px 0 20px 20px;
     width: 200px;
     .item{
       position: relative;
       list-style:none;
       font-size:14px;
       font-weight:600;
       line-height:20px;
       padding: 20px 0 20px 28px;
       text-align: left;
       cursor: pointer;
       &.active{
         color: #0081FF;
       }
       &:after{
         position: absolute;
         content: '';
         height: 100%;
         width: 0;
         left: 8px;
         border-left: 1px solid #BFBFBF;
       }
       &:first-child:after{
         top: 29px;
       }
       &:last-child:after{
         bottom: 29px;
       }
       .range-icon{
         position: absolute;
         left: 1px;
         top: 23px;
         width: 15px;
         height: 15px;
         background: url("../../assets/pngs/scroll-default.png") no-repeat center center;
         background-size:5px 5px;
         z-index: 2;
         &.active{
           color: #0081FF;
           background: url("../../assets/pngs/scroll-active.png") no-repeat center center;
           background-size: 15px 15px;
         }
       }
     }
    }
   .content-list{
     margin-left: 220px;
      flex: 1;
      .item{
        /*height: 400px;*/
        padding: 40px 50px;
        background: #ffffff;
        &:not(:last-child){
          margin-bottom: 20px;
        }
        .title{
          font-size:22px;
          font-weight:600;
          color:rgba(40,40,40,1);
          line-height:30px;
          text-align: left;
        }
        .des{
          font-size:16px;
          font-weight:400;
          color:rgba(40,40,40,1);
          line-height:26px;
          text-align: left;
          .author{
            margin-top: 20px;
            text-align: right;
            span{
              position: relative;
              &:before{
                position: absolute;
                top: 9px;
                left: -32px;
                width: 26px;
                border-top: 1px solid #282828;
                content: '';
              }
            }
          }
        }
        .info{
          display: flex;
          margin-top: 40px;
          .pic{
            margin-right: 50px;
            width:326px;
            height:200px;
            border-radius:4px;
          }
          .des{
            flex: 1;
          }
        }
        .intro{
          margin-top: 40px;
          text-align: left;
          font-size:16px;
          color:rgba(40,40,40,1);
          ul{
            display: flex;
            li{
              margin-right: 85px;
              &:nth-child(2){
                margin-right: 135px;
              }
            }
          }
          .intro-title{
            font-weight:600;
            line-height:22px;
          }
          .intro-detail{
            margin-top: 10px;
            line-height: 26px;
          }
        }
      }
    }
  }
}
</style>
